var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIcnMarketplaceX2Y2 = function SvgIcnMarketplaceX2Y2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#icn_marketplace_x2y2_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.925 6.698a7.413 7.413 0 1 0 0 10.605 8.721 8.721 0 1 1 0-10.605Z",
    fill: "url(#icn_marketplace_x2y2_svg__b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.205 16.242a5.93 5.93 0 1 0 0-8.484 6.977 6.977 0 1 1 0 8.484Z",
    fill: "url(#icn_marketplace_x2y2_svg__c)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 6.768a5.233 5.233 0 1 1 0 10.465 5.233 5.233 0 0 1 0-10.465Zm0 1.744a3.489 3.489 0 1 1 0 6.977 3.489 3.489 0 0 1 0-6.977Z",
    fill: "url(#icn_marketplace_x2y2_svg__d)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "icn_marketplace_x2y2_svg__b",
    x1: 18.925,
    y1: 12.001,
    x2: 2.58,
    y2: 12.001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5334C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0BDFF6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icn_marketplace_x2y2_svg__c",
    x1: 20.721,
    y1: 12,
    x2: 7.646,
    y2: 12,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5334C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0BDFF6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icn_marketplace_x2y2_svg__d",
    x1: 21,
    y1: 12.001,
    x2: 3,
    y2: 12.001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5334C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0BDFF6"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "icn_marketplace_x2y2_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgIcnMarketplaceX2Y2;